import { resolveAsAttachment } from '@algbra/ui/resolvers'
import { GatsbyResolvedAsset } from '@algbra/ui/types/image'
import { map } from 'rambdax'
import styles from './LogoList.module.scss'
import Permalink from '@algbra/ui/components/Permalink/Permalink'

export type Logo = {
  id: string
  image: GatsbyResolvedAsset
  title: string
  link: string
}
export type ZoneLogoListProps = {
  __typename: 'StrapiGQL_ComponentZonesLogoList'
  title: string
  items: Logo[]
}
export function ZoneLogoList({ items }: ZoneLogoListProps) {
  return (
    <div className={styles.list}>
      {map(
        ({ image, title, link }) =>
          link ? (
            <Permalink
              to={link}
              isExternal={true}
              isBlank={true}
              className={styles.item}
              key={image.id}
            >
              <img
                src={resolveAsAttachment(image)}
                alt={`Logo: ${title}`}
                loading="lazy"
                width="100%"
              />
            </Permalink>
          ) : (
            <span className={styles.item} key={image.id}>
              <img
                src={resolveAsAttachment(image)}
                alt={`Logo: ${title}`}
                loading="lazy"
                width="100%"
              />
            </span>
          ),
        items || []
      )}
    </div>
  )
}
